import { Link } from 'react-router-dom';
import './NotFoundPage.sass';

export const NotFoundPage = () => (
	<div className='not-found-page'>
		<Link to='/pages' className='not-found-page__link'>
			Вернуться на главную
		</Link>
		<div className='not-found-page__container'>
			<h1 className='not-found-page__title'>Страница не найдена</h1>
		</div>
	</div>
);
